import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FilterService } from '../../../services/filter.service';
import { LocationService } from '../../../services/location.service';
import { Page } from '../../../models/paging/page';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss']
})
export class LocationComponent implements OnInit {
  loading: boolean = false;
  readOnly: boolean = false;
  rows = [];
 page = new Page();
 company_Id;
  filter: any = {
    company_Id: undefined,
    name: '',
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  constructor(private locationService: LocationService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    this.filter.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];
    this.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];

    if (this.authService.currentUser.value.userProfileId != 1 && this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }

    if (this.authService.currentUser.value.userProfileId == 3) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['']);
    }

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "name";

    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable()
    }
  }

  ngOnInit(): void {
    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.locationService.getTable(this.page, this.filter.company_Id, this.filter.name).then((rows) => {
      //console.log(rows);
      this.page = rows.page;
      this.rows = rows.data;
      this.loading = false;
    });
  }

  rebind() {
    this.loadTable();
  }
  
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.filter.company_Id = this.company_Id;
    this.loadTable();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;

    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }
    this.loadTable();

  }

  add() {
    this.router.navigate(['admin/locations/manage'], { queryParams: { company_Id: this.filter.company_Id } });
  }

  edit(row) {
    this.router.navigate(['admin/locations/manage'], { queryParams: { id: row.id, company_Id: this.filter.company_Id } });
  }

  view(row) {
    this.router.navigate(['admin/sublocations'], { queryParams: { location_id: row.id, company_Id: this.filter.company_Id } });
  }
  back() {
    if (this.authService.currentUser.value.userProfileId == 3) {
      this.router.navigate(['']);
    } else {
      this.router.navigate(['admin/companies/overview'], { queryParams: { id: this.filter.company_Id } });
    }
  }
getRowClass = (row) => {
    return {
      'row-expired': row.expired,
      'row':true
    }
  }
}
